export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: '100vh',
    },
    cardContainer: {
        padding: '20px 20px 0px 20px'
    },
    paraText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
    },
    mainHeadingText: {
        fontSize: theme.typography.h4,
        fontWeight: 600
    },
    btnText: {
        fontSize: '14px',
        fontWeight: '600',
    },
    saveBtn: {
        backgroundColor: '#0B51C5',
        borderRadius: '20px',
        pointer: 'cursor'
    },
    cancelBtn: {
        backgroundColor: '#DEDEDE',
        borderRadius: '20px',
        pointer: 'cursor'
    }
})